import DesignTokens from '@tableau/design-tokens';
import { TabStyles } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';

import { Messages } from '~src/codegen/Localize';
import { FieldArray } from '~src/settings/FormikWrapperForStubbing';
import { applyColor }from '~src/style/ColorService';

import { DataConnectClusterNodesSectionHeaders } from '../dataConnectClusterNodes/DataConnectClusterNodesSectionHeaders';
import { DataConnectClusterNodesTableRow } from '../dataConnectClusterNodes/DataConnectClusterNodesTableRow';
import { Alert } from '../types/Alert';
import { ClusterID } from '../types/Cluster';
import { Node } from '../types/Node';
import { NodeResUsage } from '../types/NodeResUsage';

export type MultiClusterTableEntryNodesProps = Readonly<{
  clusterId: ClusterID;
  clusterName: string;
  nodes: Node[];
  nodesResUsage: Record<string, NodeResUsage>;
  nodesAlerts: Record<string, ReadonlyArray<Alert>>;
  allowRejectNode: boolean;
  allowDeleteNode: boolean;
  allowApproveNode: boolean;
  refreshPoolsAndClusters: () => void;
}>;
export const POOL_NODE_FIELD = 'settings.siteAdminBridgeSettings.poolNodeSettings.nodes';

export function DataConnectMultiClusterTableEntryNodes(props: MultiClusterTableEntryNodesProps) {
  const {nodesResUsage, nodesAlerts} = props;
  return (
    <table className={multiClusterRowTableStyle}>
      { props.nodes.length !==0 ? <DataConnectClusterNodesSectionHeaders isDefaultPool={true} />:<></>}
      <tbody>
        <FieldArray
          name={POOL_NODE_FIELD}
          render={() => (
            props.nodes.length === 0?
            <tr>
              <td colSpan={7} style={{paddingLeft: 0}}>
                <div className={'tb-data-grid-cell-text-data-connect tb-data-grid-DataConnect-center'}>
                  { Messages.dataConnectSiteSettingsClusterNodeDefaultRowDescription()}
                </div>
              </td>
            </tr>
          :
            props.nodes.map((node: Node, index: number) => (
              <tr key={index}>
                <DataConnectClusterNodesTableRow
                  node={node}
                  nodeResUsage={nodesResUsage[node.nodeId]}
                  nodeAlerts={nodesAlerts[node.nodeName]}
                  index={index}
                  clusterTestId={'cluster-'+props.clusterId+'-'}
                  clusterId={props.clusterId}
                  allowRejectNode={props.allowRejectNode}
                  allowDeleteNode={props.allowDeleteNode}
                  allowApproveNode={props.allowApproveNode}
                  refreshPoolsAndClusters={props.refreshPoolsAndClusters}
                />
              </tr>))
          )}
        />
      </tbody>
    </table>
  );
}

export const multiClusterRowTableStyle = style({
  borderSpacing: 0,
  textAlign: 'left',
  backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, TabStyles.Colors.White),
  cursor: 'default',
  paddingTop: 16,
  paddingBottom: 24,
  width: '100%'
});